import React from 'react';
import { motion } from 'framer-motion';
import { projects } from '../data/projects';
const [lead, ...supporting] = projects;
export function ProjectShowcase() {
  return <section id="developments" className="bg-[#0A0A0A] py-24 px-6 md:px-10" data-id="element-135" data-mp="3rbvb7a050gzc">
      <div className="max-w-7xl mx-auto" data-id="element-136" data-mp="3rdxz9ohqc01f">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14" data-id="element-137" data-mp="3narukla9mgx2">
          <div data-id="element-138" data-mp="nvo8p6tgkps5">
            <p className="text-[#C5A55A] text-xs tracking-[0.3em] uppercase mb-4" data-id="element-139" data-mp="nu3czdver0sp">
              The developments
            </p>
            <h2 className="text-3xl md:text-5xl font-serif font-bold text-white" data-id="element-140" data-mp="iwtr2878979m">
              Built, leased and standing today
            </h2>
          </div>
          <p className="text-gray-400 max-w-sm" data-id="element-141" data-mp="a4jggpsf6zru">
            Southwest Florida property, from raw land through completed,
            occupied buildings.
          </p>
        </div>

        {/* Lead project */}
        <motion.figure initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative mb-6 overflow-hidden" data-id="element-142" data-mp="11tux7wcipdf5">
          <img src={lead.image} alt={lead.name} className="w-full h-[45vh] md:h-[65vh] object-cover" data-id="element-143" data-mp="179k4q3g1ahsc" />
          <div className="absolute inset-0 bg-black/45" aria-hidden="true" data-id="element-144" data-mp="1c5sknj222f0k" />
          <figcaption className="absolute bottom-0 left-0 p-8 md:p-12 max-w-2xl" data-id="element-145" data-mp="13772vq4er40u">
            <span className="text-[#C5A55A] text-xs tracking-[0.25em] uppercase" data-id="element-146" data-mp="13544ahp6w2ki">
              {lead.category} · {lead.year}
            </span>
            <h3 className="text-3xl md:text-5xl font-serif font-bold text-white mt-3 mb-3" data-id="element-147" data-mp="t87sa2030yb7">
              {lead.name}
            </h3>
            <p className="text-gray-200 text-lg" data-id="element-148" data-mp="2iogyfqn5xv61">{lead.detail}</p>
          </figcaption>
        </motion.figure>

        {/* Supporting projects */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-149" data-mp="2m5ljn0nzppfu">
          {supporting.map((project, index) => <motion.figure key={project.name} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex flex-col" data-id="element-150" data-mp="2h5qogkx6mdoz" data-mpi={index}>
              <div className="overflow-hidden" data-id="element-151" data-mp="2zy1p084d5zjx">
                <img src={project.image} alt={project.name} className="w-full h-56 object-cover" data-id="element-152" data-mp="2v61ifwtsg8ed" />
              </div>
              <figcaption className="pt-5 flex flex-col flex-grow border-t-2 border-[#C5A55A] mt-0" data-id="element-153" data-mp="3nmuf3nyb1d6m">
                <span className="text-[#C5A55A] text-[11px] tracking-[0.2em] uppercase" data-id="element-154" data-mp="3iwe03zeu5ji5">
                  {project.category}
                </span>
                <h3 className="text-xl font-serif font-bold text-white mt-2 mb-2" data-id="element-155" data-mp="15f2he9q5bmqo">
                  {project.name}
                </h3>
                <p className="text-gray-400 text-sm leading-relaxed" data-id="element-156" data-mp="1ee621i4yoa7a">
                  {project.detail}
                </p>
                <span className="text-gray-500 text-xs mt-auto pt-4" data-id="element-157" data-mp="1jdshly89i2j9">
                  {project.year}
                </span>
              </figcaption>
            </motion.figure>)}
        </div>
      </div>
    </section>;
}